/**
 * ContactPreferencesService - שירות לניהול העדפות איש קשר
 * מספק פונקציות CRUD בסיסיות + פונקציות מותאמות אישית
 */

import apiClient from "../core/apiClient";
import { ContactPreferences, ContactPreferenceType } from "../interfaces/DTO/contactPreferences";
import { BaseService } from "./BaseService";

const API_URL = "/contact-preferences";

class ContactPreferencesService extends BaseService<ContactPreferences> {
  constructor() {
    super(API_URL);
  }

  /**
   * שליפת כל ההעדפות של איש קשר מסוים
   */
  async getByContactId(contactId: number): Promise<ContactPreferences[]> {
    const response = await apiClient.get<ContactPreferences[]>(
      `${this.baseUrl}/contact/${contactId}`
    );
    return response.data;
  }

  /**
   * שליפת העדפות לפי איש קשר וסוג העדפה
   */
  async getByContactAndType(
    contactId: number,
    preferenceType: ContactPreferenceType
  ): Promise<ContactPreferences[]> {
    const response = await apiClient.get<ContactPreferences[]>(
      `${this.baseUrl}/contact/${contactId}/type/${preferenceType}`
    );
    return response.data;
  }

  /**
   * שליפת העדפה ספציפית לפי איש קשר, סוג ותקופה
   */
  async getByContactTypeAndPeriod(
    contactId: number,
    preferenceType: ContactPreferenceType,
    reportedPeriod: string  // ISO date string
  ): Promise<ContactPreferences | null> {
    const response = await apiClient.get<ContactPreferences>(
      `${this.baseUrl}/contact/${contactId}/type/${preferenceType}/period`,
      { params: { reported_period: reportedPeriod } }
    );
    return response.data;
  }

  /**
   * שליפת העדפות משפחתיות לפי family_id
   */
  async getFamilyPreferences(familyId: number): Promise<ContactPreferences[]> {
    const response = await apiClient.get<ContactPreferences[]>(
      `${this.baseUrl}/family/${familyId}`
    );
    return response.data;
  }

  /**
   * שליפת ההעדפות האחרונות (לפי reported_period) לכל preference_type
   * מחזיר רשומה אחת לכל סוג העדפה עם התקופה המדווחת האחרונה
   */
  async getByContactLast(contactId: number): Promise<ContactPreferences[]> {
    const response = await apiClient.get<ContactPreferences[]>(
      `${this.baseUrl}/contact/${contactId}/last`
    );
    return response.data;
  }

  /**
   * שליפת ההעדפות המשפחתיות האחרונות (לפי reported_period) לכל preference_type
   * מחזיר רק העדפות משפחתיות עם התקופה המדווחת האחרונה
   */
  async getFamilyPreferencesLast(familyId: number): Promise<ContactPreferences[]> {
    const response = await apiClient.get<ContactPreferences[]>(
      `${this.baseUrl}/family/${familyId}/last`
    );
    return response.data;
  }
}

// יצירת instance יחיד של השירות
export const contactPreferencesService = new ContactPreferencesService();
